<div [ngClass]="question.styles" [formGroup]="formGroup" *ngIf="formGroup">
    <mat-checkbox
        [formControlName]="option.key"
        class="ca-checkbox"
        [disableRipple]="true"
        [id]="question.groupName + option.key"
        [attr.data-testid]="question.groupName + option.key"
        *ngFor="let option of question.questions; let isLast = last"
        [ngClass]="{ 'mb-0': isLast, hidden: option.hidden }"
    >
        {{ option.label | translate }}
    </mat-checkbox>
    <div *ngIf="question.validators?.length" class="vp-subscript relative mt-2">
        <div class="absolute vp-error-message" *ngIf="isInvalid && isTouched" @slideDown>
            <ca-form-error-message>
                {{ errorMessage | translate }}
            </ca-form-error-message>
        </div>
    </div>
</div>
